import React from 'react';
// Constants
import { CompanyName, LocationCity } from '../../utils/Constants';
// Data
import {
  carpentryPageAdditionalMeta,
  carpentryPageStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import CarpentryPageMainContainer from '../../components/carpentry/CarpentryPageMainContainer';
import GeneralHeader from '../../components/headers/GeneralHeader';
import FooterComponent from '../../components/footer/FooterComponent';

function CarpentryPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Carpentry'
        desc={`Discover expert carpentry services in ${LocationCity} with ${CompanyName}. From bespoke woodwork to high-quality joinery, we bring craftsmanship and precision to every project.`}
        keywords={`carpentry, bespoke woodwork, joinery, custom furniture, timber framing, ${CompanyName}, skilled carpenters, ${LocationCity}, UK`}
        additionalMeta={carpentryPageAdditionalMeta}
        structuredData={carpentryPageStructuredData}
      />

      <div className='grid min-h-screen overflow-hidden bg-colour3 text-colour2 dark:bg-colour2 dark:text-colour1 font-poppins'>
        <div className='grid'>
          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <GeneralHeader ServiceName='Carpentry' bgImage={'bg-carpentry'} />

          {/* Main page content */}
          <CarpentryPageMainContainer />

          {/* Footer */}
          <FooterComponent />
        </div>
      </div>
    </>
  );
}

export default CarpentryPage;
